// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import CzechRepublic from '../_raw/flag/icon_flag_czech_republic.png';

export default () => <img src={CzechRepublic} alt="CzechRepublic" />;
